<template>
    <div class="text-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-12 h-12 mx-auto text-gray-400">
          <path fill-rule="evenodd" d="M10 1a4.5 4.5 0 00-4.5 4.5V9H5a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-.5V5.5A4.5 4.5 0 0010 1zm3 8V5.5a3 3 0 10-6 0V9h6z" clip-rule="evenodd" />
        </svg>
        <h3 v-if="attributeCount" class="mt-2 text-sm font-medium text-gray-900">{{ attributeCount }} {{ attributeTitle }} Found</h3>
        <h3 v-else class="mt-2 text-sm font-medium text-gray-900">{{ attributeTitle }} Found</h3>
        <p class="mt-1 text-sm text-gray-500">{{ text }}</p>
        <div class="mt-6">
            <button v-if="isGuest" type="button" @click="toLogin" class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                <svg class="w-5 h-5 mr-2 -ml-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 26" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>
                Login or Sign up
            </button>
            <button v-else type="button" @click="toBilling" class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                <svg class="w-5 h-5 mr-2 -ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                </svg>
                Upgrade To Unlock
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        attributeName: {
            type: String,
            required: true,
        },
        attributeCount: {
            type: Number,
            required: false,
            default: 0,
        },
        attributeTitle: {
            type: String,
            required: true,
        },
        isGuest: {
            type: Boolean,
            required: false,
        },
        text: {
            type: String,
            required: false,
            default: 'Upgrade to see results.'
        },
    },
    data () {
        return {};
    },
    methods: {
        toBilling() {
            window.location = this.route('billing.index');
        },
        toLogin() {
            window.location = this.route('login');
        },
    },
};
</script>
